module.exports = __webpack_public_path__ + "img/ico-slots.eb77e624.svg";